import { render } from "./AppTopbar.vue?vue&type=template&id=b95e6e7e&scoped=true"
import script from "./AppTopbar.vue?vue&type=script&setup=true&lang=js"
export * from "./AppTopbar.vue?vue&type=script&setup=true&lang=js"

import "./AppTopbar.vue?vue&type=style&index=0&id=b95e6e7e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b95e6e7e"],['__file',"src/core/layout/AppTopbar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b95e6e7e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b95e6e7e', __exports__)) {
    console.log('reload')
    api.reload('b95e6e7e', __exports__)
  }
  
  module.hot.accept("./AppTopbar.vue?vue&type=template&id=b95e6e7e&scoped=true", () => {
    console.log('re-render')
    api.rerender('b95e6e7e', render)
  })

}


export default __exports__